import {BasketState} from '../../redux/basket/interface';

export interface BasketUnit {
	entry: BasketState['data'][number],
	index: number
}

export function ft_genLinkId(): string {
	return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}

export function ft_basketUnits(data: BasketState['data']): BasketUnit[] {
	const units: BasketUnit[] = [];

	data.forEach((entry) => {
		for (let i = 0; i < entry.quantity; i++)
			units.push({entry, index: i});
	});

	return units;
}

export function ft_getLinkedUnit(data: BasketState['data'], source: BasketUnit): BasketUnit | undefined {
	const link = source.entry.link?.[source.index];

	if (!link)
		return undefined;

	return ft_basketUnits(data).find(u => (
		u.entry.link?.[u.index] === link
		&& !(u.entry === source.entry && u.index === source.index)
	));
}

export function ft_getUnlinkedDevices(data: BasketState['data'], chargerId: string): BasketUnit[] {
	const units = ft_basketUnits(data);

	const chargerLinks = new Set(
		units
		.filter(u => u.entry.device._id === chargerId)
		.map(u => u.entry.link?.[u.index])
		.filter((l): l is string => !!l)
	);

	return units.filter((u) => {
		const category = u.entry.device.category;
		const link = u.entry.link?.[u.index];

		return category.needCharger && category.charger?._id === chargerId && !(link && chargerLinks.has(link));
	});
}